import { ResizedImage } from '@ah/design/mobile';
import type { ChosenSuperconnector } from '@ah/people/shared';
import { MAIA_PNG } from '../../assets';

const FALLBACK_NARRATION = 'Worth taking a look?';

export function SuperconnectorBubble({
  godmother,
  narration,
  fallback = FALLBACK_NARRATION,
  large = false,
  centered = false,
}: {
  godmother: ChosenSuperconnector | null;
  narration?: string | null;
  fallback?: string;
  large?: boolean;
  centered?: boolean;
}) {
  const text = narration?.trim() ? narration : fallback;
  const pictureUrl = godmother?.pictureUrl ?? MAIA_PNG;
  const alt = godmother?.firstName ?? 'Your Underling';

  if (centered) {
    return (
      <div className="flex flex-col items-center text-center gap-4 py-4">
        <ResizedImage
          src={pictureUrl}
          renderWidth={96}
          fallback={false}
          alt={alt}
          className="w-24 h-24 rounded-full object-cover ring-4 ring-primary/10"
        />
        <p className="text-xl font-semibold leading-snug text-foreground max-w-[28ch]">
          {text}
        </p>
        <p className="text-[13px] leading-relaxed text-muted-foreground max-w-[32ch]">
          Answering helps me connect you with the right people, ideas, and rooms.
        </p>
      </div>
    );
  }

  return (
    <div className="flex items-start gap-2.5">
      <ResizedImage
        src={pictureUrl}
        renderWidth={large ? 40 : 32}
        fallback={false}
        alt={alt}
        className={`${large ? 'w-10 h-10' : 'w-8 h-8'} rounded-full object-cover shrink-0 mt-0.5`}
      />
      <div className={`flex-1 bg-muted/50 rounded-2xl rounded-tl-sm ${large ? 'px-5 py-3.5' : 'px-4 py-2.5'}`}>
        <p className={`${large ? 'text-lg font-semibold leading-snug' : 'text-[15px] font-medium leading-snug'}`}>
          {text}
        </p>
      </div>
    </div>
  );
}
